import countries from './countries.json';

export type CountryT = { name: string; code: string };

/**
 * Verbatim copy of Cobalt's country list
 * (services/vendor-integration/cobalt/src/pages/Settings/countries.json).
 * A vendor's `company.country` is always one of these English names, so this
 * is the exact way to get its ISO 3166-1 alpha-2 code on the storefront.
 */
export const COUNTRIES: CountryT[] = countries;
